/**
 *
 * Sidebar
 *
 */

import "./styles.scss";

import { API, Endpoints } from "utils/api";
import { DoctorPlaceholder, UserPlaceholder } from "utils/utils";
import { DndControl, Icon, Icons } from "components";
import { localhostType, psychologistsSubDomains, usersSubDomains } from "screens/App/routes";
import { setLanguage, setLogout, setNav, setNotificationToken, setPagesModal } from "store/actions";

import { Drawer } from "antd";
import Logo from "assets/images/logo_team24@1x.png";
import React from "react";
import Strings from "utils/strings";
import { connect } from "react-redux";
import { push } from "connected-react-router";

export class Sidebar extends React.PureComponent<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			activeTab: "/dashboard"
		};

		this.selectTab = this.selectTab.bind(this);
		this.goTo = this.goTo.bind(this);
	}

	selectTab(url: String) {
		const { activeTab } = this.state;

		this.setState({ activeTab: activeTab === url ? "" : url });
	}

	goTo(url: String) {
		this.setState({ activeTab: url });
		this.props.dispatch(push(`/${url}`));
	}

	mobileGoTo(url: String) {
		const { dispatch } = this.props;

		this.setState({ activeTab: url });
		dispatch(push(`/${url}`));
		dispatch(setNav(false));
	}

	logout() {
		const { dispatch, notificationToken } = this.props;

		API.post({
			url: Endpoints.uriLogout(),
			data: {
				notificationToken
			}
		});

		localStorage.removeItem("token");
		dispatch(setNav(false));
		dispatch(setLogout());
		dispatch(push("/"));
	}

	async changeLanguage(lang: string) {
		const { dispatch, notificationToken } = this.props;

		dispatch(setLanguage(lang));
		dispatch(setNotificationToken(notificationToken));

		await API.post({
			url: Endpoints.uriNotificationToken(),
			data: {
				notificationToken,
				device: "web",
				language: lang
			}
		});
	}

	renderDrawer() {
		const { nav, dispatch, user, language } = this.props;
		const path = window.location?.pathname?.substring(1).split("/");
		const hostname = window.location.hostname?.split(".")?.[0];

		return (
			<Drawer
				title={null}
				footer={null}
				className="drawer MobileNavDrawer"
				width="100%"
				placement="left"
				closable={false}
				visible={nav}
				onClose={() => dispatch(setNav(false))}
			>
				<div className="MobileNavBar">
					<button onClick={() => dispatch(setNav(false))} className="MobileNavClose">
						<Icon name="close" />
					</button>
					<div className="UserContainer">
						<button onClick={() => this.mobileGoTo("profile")}>
							<img
								src={user?.photo || (user?.role === "user" ? UserPlaceholder : DoctorPlaceholder)}
								alt="user avatar"
							/>
						</button>
						<div className="UserDetails">
							<p>
								{Strings.sidebar.hello}{" "}
								{user?.role === "user" || user?.isHR ? user?.name : user?.externalName || user?.name}!
							</p>
							{user?.business ? <p>{user.business}</p> : <p>&nbsp;</p>}
						</div>
					</div>
					<div className="SidebarContent">
						<div className="SidebarMenus">
							<a
								href="/home"
								onClick={(e) => {
									e.preventDefault();
									this.mobileGoTo("home");
								}}
								className={`SidebarMenuObject${
									path?.[0] === "home" || path?.[0] === "" ? " --menu-active" : ""
								}`}
							>
								<span className="SidebarMenuIcon">
									{path?.[0] === "home" ? <Icons.HomeFilled /> : <Icons.Home />}
								</span>
								<p>{Strings.sidebar.home}</p>
							</a>
							{user?.isHR && (
								<React.Fragment>
									<a
										href="/dashboard"
										onClick={(e) => {
											e.preventDefault();
											this.mobileGoTo("dashboard");
										}}
										className={`SidebarMenuObject${
											path?.[0] === "dashboard" ? " --menu-active" : ""
										}`}
									>
										<span className="SidebarMenuIcon">
											{path?.[0] === "dashboard" ? (
												<Icons.DashboardFilled />
											) : (
												<Icons.Dashboard />
											)}
										</span>
										<p>{Strings.sidebar.dashboard}</p>
									</a>
									<a
										href="/coworkers"
										onClick={(e) => {
											e.preventDefault();
											this.mobileGoTo("coworkers");
										}}
										className={`SidebarMenuObject${
											path?.[0] === "coworkers" ? " --menu-active" : ""
										}`}
									>
										<span className="SidebarMenuIcon">
											{path?.[0] === "coworkers" ? <Icons.UsersFilled /> : <Icons.Users />}
										</span>
										<p>{Strings.sidebar.coworkers}</p>
									</a>
								</React.Fragment>
							)}
							{/* @ts-ignore */}
							{((hostname === "localhost" && localhostType === "psychologists") ||
								psychologistsSubDomains.includes(hostname)) && (
								<React.Fragment>
									<a
										href="/patients"
										onClick={(e) => {
											e.preventDefault();
											this.mobileGoTo("patients");
										}}
										className={`SidebarMenuObject${path?.[0] === "patients" ? " --menu-active" : ""}`}
									>
										<span className="SidebarMenuIcon">
											{path?.[0] === "patients" ? <Icons.UsersFilled /> : <Icons.Users />}
										</span>
										<p>{Strings.sidebar.patients}</p>
									</a>
									<DndControl variant="sidebar" />
								</React.Fragment>
							)}
							<a
								href="/appointments"
								onClick={(e) => {
									e.preventDefault();
									this.mobileGoTo("appointments");
								}}
								className={`SidebarMenuObject${path?.[0] === "appointments" ? " --menu-active" : ""}`}
							>
								<span className="SidebarMenuIcon">
									{path?.[0] === "appointments" ? <Icons.CalendarFilled /> : <Icons.Calendar />}
								</span>
								<p>{Strings.sidebar.appointments}</p>
							</a>
							<a
								href="/chat"
								onClick={(e) => {
									e.preventDefault();
									this.mobileGoTo("chat");
								}}
								className={`SidebarMenuObject${path?.[0] === "chat" ? " --menu-active" : ""}`}
							>
								<span className="SidebarMenuIcon">
									{path?.[0] === "chat" ? <Icons.ChatFilled /> : <Icons.Chat />}
								</span>
								<p>{Strings.sidebar.chat}</p>
							</a>
							<a
								href="/profile"
								onClick={(e) => {
									e.preventDefault();
									this.mobileGoTo("profile");
								}}
								className={`SidebarMenuObject${path?.[0] === "profile" ? " --menu-active" : ""}`}
							>
								<span className="SidebarMenuIcon">
									{path?.[0] === "profile" ? <Icons.ProfileFilled /> : <Icons.Profile />}
								</span>
								<p>{Strings.sidebar.profile}</p>
							</a>
							<div className="SidebarSeparator" />
							{/* @ts-ignore */}
							{((hostname === "localhost" && localhostType === "users") ||
								usersSubDomains.includes(hostname)) && (
								<a
									href="/contact-us"
									onClick={(e) => {
										e.preventDefault();
										this.mobileGoTo("contact-us");
									}}
									className={`SidebarMenuObject${path?.[0] === "contact-us" ? " --menu-active" : ""}`}
								>
									<span className="SidebarMenuIcon">
										<Icons.Message color="white" />
									</span>
									<p>{Strings.sidebar.contactUs}</p>
								</a>
							)}
							<a
								href="/"
								onClick={(e) => {
									e.preventDefault();
									this.logout();
								}}
								className="SidebarMenuObject"
							>
								<span className="SidebarMenuIcon">
									<Icons.Door color="white" />
								</span>
								<p>{Strings.sidebar.terminate}</p>
							</a>
						</div>
						<div className="MobileNavLanguage">
							<div className="SidebarSeparator" />
							<div className="LanguagePicker">
								<button
									className={language === "pt" ? "--btn-active" : ""}
									onClick={() => this.changeLanguage("pt")}
								>
									PT
								</button>
								<div className="ButtonSeparator" />
								<button
									className={language === "en" ? "--btn-active" : ""}
									onClick={() => this.changeLanguage("en")}
								>
									EN
								</button>
								<div className="ButtonSeparator" />
								<button
									className={language === "es" ? "--btn-active" : ""}
									onClick={() => this.changeLanguage("es")}
								>
									ES
								</button>
							</div>
							<div className="SidebarSeparator" />
						</div>
						<div className="SidebarLinks">
							<div className="SidebarLegalLinks">
								<button
									onClick={() => {
										dispatch(setPagesModal("tc"));
										dispatch(setNav(false));
									}}
								>
									{Strings.sidebar.terms}
								</button>
								<button
									onClick={() => {
										dispatch(setPagesModal("pp"));
										dispatch(setNav(false));
									}}
								>
									{Strings.sidebar.privacy}
								</button>
							</div>
						</div>
					</div>
				</div>
			</Drawer>
		);
	}

	render() {
		const { dispatch, user } = this.props;
		const path = window.location?.pathname?.substring(1).split("/");
		const hostname = window.location.hostname?.split(".")?.[0];

		return (
			<React.Fragment>
				<div className="SidebarWrapper">
					<div className="SidebarContainer open">
						<div className="UserContainer">
							<button onClick={() => this.goTo("profile")}>
								<img
									src={user?.photo || (user?.role === "user" ? UserPlaceholder : DoctorPlaceholder)}
									alt="user avatar"
								/>
							</button>
							<div className="UserDetails">
								<p>
									{Strings.sidebar.hello}{" "}
									{user?.role === "user" || user?.isHR
										? user?.name
										: user?.externalName || user?.name}
									!
								</p>
								{user?.business ? <p>{user.business}</p> : <p>&nbsp;</p>}
							</div>
						</div>
						<div className="SidebarContent">
							<div className="SidebarMenus">
								{!user?.isHR && (
									<a
										href="/home"
										onClick={(e) => {
											e.preventDefault();
											this.goTo("home");
										}}
										className={`SidebarMenuObject${
											path?.[0] === "home" || path?.[0] === "" ? " --menu-active" : ""
										}`}
									>
										<span className="SidebarMenuIcon">
											{path?.[0] === "home" ? <Icons.HomeFilled /> : <Icons.Home />}
										</span>
										<p>{Strings.sidebar.home}</p>
									</a>
								)}
								{user?.isHR && (
									<React.Fragment>
										<a
											href="/dashboard"
											onClick={(e) => {
												e.preventDefault();
												this.goTo("dashboard");
											}}
											className={`SidebarMenuObject${
												path?.[0] === "dashboard" ? " --menu-active" : ""
											}`}
										>
											<span className="SidebarMenuIcon">
												{path?.[0] === "dashboard" ? (
													<Icons.DashboardFilled />
												) : (
													<Icons.Dashboard />
												)}
											</span>
											<p>{Strings.sidebar.dashboard}</p>
										</a>
										<a
											href="/coworkers"
											onClick={(e) => {
												e.preventDefault();
												this.goTo("coworkers");
											}}
											className={`SidebarMenuObject${
												path?.[0] === "coworkers" ? " --menu-active" : ""
											}`}
										>
											<span className="SidebarMenuIcon">
												{path?.[0] === "coworkers" ? <Icons.UsersFilled /> : <Icons.Users />}
											</span>
											<p>{Strings.sidebar.coworkers}</p>
										</a>
									</React.Fragment>
								)}
								{/* @ts-ignore */}
								{((hostname === "localhost" && localhostType === "psychologists") ||
									psychologistsSubDomains.includes(hostname)) && (
									<a
										href="/patients"
										onClick={(e) => {
											e.preventDefault();
											this.goTo("patients");
										}}
										className={`SidebarMenuObject${
											path?.[0] === "patients" ? " --menu-active" : ""
										}`}
									>
										<span className="SidebarMenuIcon">
											{path?.[0] === "patients" ? <Icons.UsersFilled /> : <Icons.Users />}
										</span>
										<p>{Strings.sidebar.patients}</p>
									</a>
								)}
								{!user?.isHR && (
									<React.Fragment>
										<a
											href="/appointments"
											onClick={(e) => {
												e.preventDefault();
												this.goTo("appointments");
											}}
											className={`SidebarMenuObject${
												path?.[0] === "appointments" ? " --menu-active" : ""
											}`}
										>
											<span className="SidebarMenuIcon">
												{path?.[0] === "appointments" ? (
													<Icons.CalendarFilled />
												) : (
													<Icons.Calendar />
												)}
											</span>
											<p>{Strings.sidebar.appointments}</p>
										</a>
										<a
											href="/chat"
											onClick={(e) => {
												e.preventDefault();
												this.goTo("chat");
											}}
											className={`SidebarMenuObject${
												path?.[0] === "chat" ? " --menu-active" : ""
											}`}
										>
											<span className="SidebarMenuIcon">
												{path?.[0] === "chat" ? <Icons.ChatFilled /> : <Icons.Chat />}
											</span>
											<p>{Strings.sidebar.chat}</p>
										</a>
									</React.Fragment>
								)}
								<a
									href="/profile"
									onClick={(e) => {
										e.preventDefault();
										this.goTo("profile");
									}}
									className={`SidebarMenuObject${path?.[0] === "profile" ? " --menu-active" : ""}`}
								>
									<span className="SidebarMenuIcon">
										{path?.[0] === "profile" ? <Icons.ProfileFilled /> : <Icons.Profile />}
									</span>
									<p>{Strings.sidebar.profile}</p>
								</a>
							</div>
							<div className="SidebarLinks">
								<div className="SidebarSeparator" />
								<div className="SidebarLogo">
									<img src={Logo} alt="sidebar logo" />
								</div>
								<div className="SidebarSeparator" />
								<div className="SidebarLegalLinks">
									<button
										onClick={() => {
											dispatch(setPagesModal("tc"));
										}}
									>
										{Strings.sidebar.terms}
									</button>
									<button
										onClick={() => {
											dispatch(setPagesModal("pp"));
										}}
									>
										{Strings.sidebar.privacy}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				{this.renderDrawer()}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	settings: state.settings,
	user: state.user,
	language: state.language,
	nav: state.nav,
	notificationToken: state.notificationToken
});

export default connect(mapStateToProps)(Sidebar);
